import localStorageService from "../../../../../helpers/localStorageService";

// Plaid OAuth redirects the browser away and back, so the in-flight link token
// and the chart-of-account it should link to must survive a full page reload.
const LINK_TOKEN_KEY = "plaid_oauth_link_token";
const TARGET_ACCOUNT_KEY = "plaid_oauth_target_account_id";
// Set when Link was opened in update mode, so the exchange on the way back knows
// it is repairing an existing connection rather than adding one.
const ITEM_ID_KEY = "plaid_oauth_item_id";

export function savePlaidOAuthState({ linkToken, targetAccountId, plaidItemId }) {
  localStorageService.set(LINK_TOKEN_KEY, linkToken);
  if (targetAccountId) {
    localStorageService.set(TARGET_ACCOUNT_KEY, targetAccountId);
  } else {
    localStorageService.remove(TARGET_ACCOUNT_KEY);
  }
  if (plaidItemId) {
    localStorageService.set(ITEM_ID_KEY, plaidItemId);
  } else {
    localStorageService.remove(ITEM_ID_KEY);
  }
}

export function loadPlaidOAuthState() {
  const plaidItemId = localStorageService.get(ITEM_ID_KEY);
  return {
    linkToken: localStorageService.get(LINK_TOKEN_KEY),
    targetAccountId: localStorageService.get(TARGET_ACCOUNT_KEY),
    plaidItemId: plaidItemId ? Number(plaidItemId) : null,
  };
}

export function clearPlaidOAuthState() {
  localStorageService.remove(LINK_TOKEN_KEY);
  localStorageService.remove(TARGET_ACCOUNT_KEY);
  localStorageService.remove(ITEM_ID_KEY);
}
